import React from 'react';
import PropTypes from 'prop-types';
import { isArray, isEmpty } from 'lodash';
import { UserContext } from '../../hoc/User';
import { SettingsContext } from '../../hoc/Settings';
import Loading from '../Loading';
import PaymentLogo from '../TinyComponents/PaymantLogo';
import { PaymentMethodsEnum } from './payment-methods-enum';
import ArcaPayment from './arca-payment';
import StripePayment from './stripe-payment';
import IdramPayment from './idram-payment';
import styles from './styles.less';

const availablePayments = [
  {
    name: PaymentMethodsEnum.ARCA,
    Component: ArcaPayment,
  },
  {
    name: PaymentMethodsEnum.STRIPE,
    Component: StripePayment,
  },
  {
    name: PaymentMethodsEnum.IDRAM,
    Component: IdramPayment,
  },
];

const isPaymentMethodEnabled = (methodName, enabledMethodsNameList) => {
  if (!isArray(enabledMethodsNameList) || isEmpty(methodName)) {
    return false;
  }

  return enabledMethodsNameList.includes(methodName);
};

const PaymentProcess = ({ orderCourse, orderLoading, course, useSchoolPayment }) => {
  const { user } = React.useContext(UserContext);
  const {
    domainSettings: {
      paymentMethods: enabledPaymentMethods
    }, // @TODO: remove deprecated paymentMethod domain setting
  } = React.useContext(SettingsContext);
  const {
    school: { isOnlinePaymentEnable, payment_app },
    price,
  } = course;

  const coursePayments = availablePayments.map(({ name }) => {
    if (useSchoolPayment) {
      return name === payment_app ? name : null;
    }

    return isPaymentMethodEnabled(name, enabledPaymentMethods) ? name : null;
  }).filter(Boolean);
  const isThereEnabledPaymentMethod = coursePayments.length > 0;

  if (!!isOnlinePaymentEnable && !isThereEnabledPaymentMethod) {
    console.warn(
      'The online Payment is enabled (isOnlinePaymentEnable is true for school) but there is no enabled payment method in domain settings!',
    );
  }

  return (
    <>
      {!!isOnlinePaymentEnable && isThereEnabledPaymentMethod && !!price && (
        <div>
          <div className={styles.payment}>
            {orderLoading && (
              <div className={styles.loading}>
                <Loading />
              </div>
            )}
            {availablePayments.map(
              ({ name, Component }) =>
                coursePayments.includes(name) && (
                  <Component orderCourse={orderCourse} orderLoading={orderLoading} key={name} />
                ),
            )}
          </div>
          {availablePayments.map(
            ({ name }) =>
              coursePayments.includes(name) && (
                <div className={styles.paymentLogo} key={name}>
                  <PaymentLogo paymentMethod={name} />
                </div>
              ),
          )}
        </div>
      )}
    </>
  );
};

PaymentProcess.propTypes = {
  orderCourse: PropTypes.func.isRequired,
  orderLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  course: PropTypes.object.isRequired,
  useSchoolPayment: PropTypes.bool,
};

PaymentProcess.defaultProps = {
  orderLoading: false,
  useSchoolPayment: false,
};

export default PaymentProcess;
